import { useContext, useEffect, useState } from "react"
import { VerticalLayout } from "./layout"
import { UserRights, UserRoles } from "./userRights"
import { deleteAPI, getAPI, postAPI } from "../api/api"
import { SettingHeader } from "../molecule/SettingHeader"
import { CustomRoleModal } from "./customModals"
import { Alert } from "./alert"
import { DeleteButton, DropdownButton, StandardButton } from "../atoms/buttons"
import { Modal, ModalBody, ModalTitle } from "./modal"
import { ToastContext, UserContext } from "../App"
import { SettingsHeader } from "../molecule/settingsHeader"

export const UserRightsComp = ({ }) => {
  const toastContext = useContext(ToastContext)
  const userInformation = useContext(UserContext)
  const isPublic = userInformation.account_type === 1
  const description = `${isPublic ? "Leads" : "Werknemers"} toevoegen / verwijderen / bewerken`
  const [roles, setRoles] = useState([
    {
      "content": "admin",
      "id": 0,
      "rights": [
        { "description": "Transacties bestellen / overzicht", selected: true },
        { "description": "Rapporten", selected: true },
        { "description": "Cursus aanmaken / bewerken", selected: true },
        { "description": "Inzicht in credits", selected: true },
        { "description": description, selected: true },
        { "description": "Bedrijfsmetrics", selected: true },
        { "description": "Bedrijfsgegevens aanpassen", selected: true },
        { "description": "Bedrijfsrollen / rechten aanpassen aanmaken", selected: true }
      ]
    },
    {
      "content": "werknemer",
      "id": 1,
      "rights": [
        { "description": "Transacties bestellen / overzicht", selected: true },
        { "description": "Rapporten", selected: true },
        { "description": "Cursus aanmaken / bewerken", selected: true },
        { "description": "Inzicht in credits", selected: false },
        { "description": description, selected: false },
        { "description": "Bedrijfsmetrics", selected: false },
        { "description": "Bedrijfsgegevens aanpassen", selected: false },
        { "description": "Bedrijfsrollen / rechten aanpassen aanmaken", selected: false }
      ]
    }
  ])
  const [activeRole, setActiveRole] = useState(0)
  const [roleModal, setRoleModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [roleError, setRoleError] = useState("")
  useEffect(() => {
    loadRoles()
  }, [])

  const loadRoles = async () => {
    const query = `api/business/roles`
    const roles = await getAPI(query)
    console.log(roles)
    setRoles(roles.data)
  }
  const handleUserRole = (id) => {
    const index = getIndex(id)
    setActiveRole(index)
  }
  function getIndex(id) {
    const copyRoles = [...roles]
    var index = 0
    copyRoles.forEach((role, i) => {
      if (role.id === id) {
        index = i
      }
    })
    return index
  }
  const handleRights = async (index) => {
    
    if (roles[activeRole].content === "admin") {
      return
    }
    const copyRoles = [...roles]
    copyRoles[activeRole].rights[index].selected = !copyRoles[activeRole].rights[index].selected
    setRoles(copyRoles)
    const body = {}
    const query = "api/business/rights/update"
    body["id_role"] = roles[activeRole].id
    body["rights"] = copyRoles[activeRole].rights.filter(role => role.selected == true)
    await postAPI(query, body)
  }
  const addNewRole = async (value) => {
    const query = "api/business/roles/create"
    const body = { role_name: value }
    const rolecreation_response = await postAPI(query, body)

    console.log(rolecreation_response)

    if (rolecreation_response.status == "ok") {
      setRoleModal(!roleModal)
      loadRoles()
      toastContext.showToast(<>De rol&nbsp;<b>{value}</b>&nbsp;is aangemaakt.</>, "success")
    } else {
        switch (rolecreation_response.message) {
          case "Duplicated data":
            setRoleError("Er bestaat al een rol met deze naam.")
            break
          case "Empty data":
            setRoleError("De naam van de rol mag niet leeg zijn.")
            break
          default:
            setRoleModal(!roleModal)
            toastContext.showToast(<>Er heeft een onbekende fout opgetreden tijdens het aanmaken van de rol.</>, "error");
            break
        }
    }
  }
  const activateDelete = () => {
    setDeleteModal(!deleteModal)
  }
  const handleDelete = () => {
    setActiveRole(0)
    loadRoles()
    setDeleteModal(!deleteModal)
  }
  return (
    <VerticalLayout className={"settings-card"}>
      <SettingsHeader
        title="Gerbuikersrollen & Rechten"
        description="Stel hier je rollen en rechten in"
        button={false}
      />
      <VerticalLayout className="phone-role settings-comp" style={{ margin: "1rem", marginTop: "unset", width:"unset", padding:"1rem" }}>
        <h6 className="medium-bold standard-text-color">Rollen</h6>

        <UserRoles
          activeRole={roles[activeRole].content}
          openModal={() => setRoleModal(!roleModal)}
          activateRole={handleUserRole}
          roles={roles} />
        {
          roles[activeRole].content === "admin" &&
          <Alert
            marginTop={"1rem"}
            type={"warning"}
            message={"Een adminrol kan niet worden verwijderd of bewerkt."}
          />
        }

        <CustomRoleModal
          visible={roleModal}
          addRole={(role) => addNewRole(role)}
          dismiss={() => setRoleModal(!roleModal)}
          error={roleError}
        />
      </VerticalLayout>
      <VerticalLayout className={"rights-view"} style={{ background: "var(--card-background-color)", padding: "1rem", width: "10", margin: "1rem", marginTop: "0.5rem" }}>
        <p className="bold-text normal-text-dark">
          Rechten
        </p>
        {roles[activeRole].rights.map((right, index) => {
          return (
            <UserRights
              changeSelected={() => handleRights(index)}
              key={index}
              rights={right}
            />
          )
        })}
      </VerticalLayout>
      {roles[activeRole].content !== "admin"
      &&
      <VerticalLayout className="standard-padding">
        <p className="small-text-light light-bold" style={{ marginBottom: "0.5rem" }}>
          Wilt u deze rol verwijderen?
        </p>
        <DeleteButton onClick={activateDelete} style={{ marginLeft: "0px" }} title={"Rol verwijderen"} />
      </VerticalLayout>
      }
      
      <DeleteRoleModal
        visible={deleteModal}
        roles={roles.filter((_,index) => index != activeRole)}
        activeRole={roles[activeRole]}
        dismiss={() => setDeleteModal(!deleteModal)}
        successDelete={() => handleDelete()}
         />
        
    </VerticalLayout>
  )
}


const DeleteRoleModal = ({ dismiss, roles, activeRole, visible, successDelete }) => {
  const [restuctureID, setRestructureID] = useState(0)
  const toastContext = useContext(ToastContext)
  const deleteRole = async () => {
    if(restuctureID != 0 && activeRole.content != "admin"){
    const url = "api/business/roles/delete"
    const body = {"id_role":activeRole["id"], "restructure_id":restuctureID}
    const deleted = await deleteAPI(url,body)
    if(deleted.status == "ok"){
        successDelete()
        setRestructureID(0)
        toastContext.showToast(<>Rol&nbsp;<b>{activeRole.content}</b>&nbsp;is verwijderd.</>, "error");
    }
    }
   
  }
  return (
    <Modal
      dismiss={dismiss}
      visible={visible}
      content={
        <>
          <ModalTitle
            hasXmark={true}
            dismissable={dismiss}
            title={"Rol verwijderen"}
          />
          <ModalBody>
            {!restuctureID && 
            <Alert
              type={"warning"}
              title={"Kies een vervangende rol"}
              message={"De huidige gebruikers moeten eerst worden toegewezen aan een nieuwe rol voordat je deze kunt verwijderen."}
            />}
           
            <p className="normal-text-light" style={{marginTop:"0.5rem"}}>Kies vervangende rol:</p>
            <DropdownButton
              dropdownStyle={{position:"relative", top:"0.5rem"}}
              optionSelected={(value) => setRestructureID(value)}
              dropdown={roles}
              content={restuctureID != 0 ?roles.filter((row => row.id == restuctureID))[0].content :activeRole.content}
            />
            <StandardButton
              onClick={() => deleteRole()}
              style={{ marginLeft: "auto", marginTop: "1rem" }}
              title={`Verwijder rol: ${activeRole.content}`}
            />
          </ModalBody>

        </>
      }
    >

    </Modal>
  )
}